import React from "react";
import {
    Modal, Fade, Typography, Box, Backdrop, Button, IconButton,
    Paper
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CloseIcon from '@mui/icons-material/Close';
import InputField from "../formElements/InputField";
import { AddBox } from '@mui/icons-material';
import SelectField from "../formElements/SelectField";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: 24,
    // p: 4,
    outline: "none",
};

const CreateNewGroup = ({ open, setOpen }) => {

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
        }

        // setOpen(false);
    }

    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>


                <Paper sx={style}>

                    <Box sx={{
                        backgroundColor: "primary.main",
                        padding: "5px 15px",
                        display: "flex",
                        flexDirection: "row",
                    }}>
                        <Box sx={{ flex: 1 }}>
                            <Typography sx={{ color: "#fff", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                Create New Group
                                <IconButton aria-label="delete"
                                    onClick={handleClose}
                                >
                                    <CloseIcon sx={{ color: '#fff' }} />
                                </IconButton>
                            </Typography>
                        </Box>

                    </Box>


                    <Box sx={{
                        padding: "15px",
                        height: { xs: "400px", sm: 'auto' },
                        overflowY: { xs: 'scroll', sm: 'hidden' },
                        '.MuiTableCell-root': {
                            padding: '10px 10px',
                            fontSize: '13px'
                        },
                    }}>
                        <TableContainer component={Paper}>
                            <Table sx={{}} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Group Name</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} align="left">Group Head</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            <InputField
                                                name='Office Furniture'
                                                placeholder='Office Furniture'
                                                size='small'
                                                type='text'
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <SelectField
                                                name='category'
                                                size='small'
                                                value='fixed assets'
                                                options={[
                                                    { option: 'Fixed Assets', value: 'fixed assets' },
                                                    { option: 'Dress', value: 'dress' },
                                                    { option: 'Foods', value: 'foods' },
                                                ]}
                                            />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <InputField
                                                name='Office Computer'
                                                placeholder='Office Computer'
                                                size='small'
                                                type='text'
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <SelectField
                                                name='category'
                                                size='small'
                                                value='fixed assets'
                                                options={[
                                                    { option: 'Fixed Assets', value: 'fixed assets' },
                                                    { option: 'Dress', value: 'dress' },
                                                    { option: 'Foods', value: 'foods' },
                                                ]}
                                            />
                                        </TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box>
                            <Button
                                size='small'
                                variant="text"
                                startIcon={<AddBox />}
                                sx={{
                                    fontSize: '14px', marginTop: '15px'
                                }}
                            >
                                Add more
                            </Button>
                        </Box>

                    </Box>


                    <Box sx={{
                        // padding : "15px",
                        // width:'100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: { xs: 'column', sm: 'row' }
                    }}>
                        <Button onClick={handleClose} variant='outlined' sx={{ flex: 1, margin: '10px', fontSize: "12px" }} >Cancel</Button>
                        <Button onClick={handleClose} variant='contained' sx={{ flex: 1, margin: '10px', fontSize: "12px" }} >Save</Button>
                    </Box>


                </Paper>
            </Fade>
        </Modal>

    );
};

export default CreateNewGroup;